// Attendance helpers — Mon–Fri working week.

export const LEAVE_LABELS = {
  CL: "Casual Leave",
  ML: "Medical Leave",
  half_day: "Half Day",
};

export const LEAVE_SHORT = {
  CL: "CL",
  ML: "ML",
  half_day: "Half",
};

export function toISODate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseISODate(s) {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
}

export function isWeekend(d) {
  const w = d.getDay(); // 0 Sun, 6 Sat
  return w === 0 || w === 6;
}

export function monthKey(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

/**
 * Return a matrix (rows of 7) representing a calendar-grid month view.
 * Weeks start Monday. Cells outside the month are marked `outside: true`.
 */
export function buildMonthGrid(year, month0) {
  const first = new Date(year, month0, 1);
  const startWeekday = (first.getDay() + 6) % 7; // Monday=0
  const gridStart = new Date(year, month0, 1 - startWeekday);
  const days = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + i);
    days.push({ date: d, outside: d.getMonth() !== month0 });
    if (i >= 27 && d.getMonth() !== month0 && (i + 1) % 7 === 0) break;
  }
  const rows = [];
  for (let i = 0; i < days.length; i += 7) rows.push(days.slice(i, i + 7));
  return rows;
}

export function monthLabel(year, month0) {
  return new Date(year, month0, 1).toLocaleDateString("en-US", { month: "long", year: "numeric" });
}

export const WEEKDAY_HEADS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
